import { Suspense } from 'react';
import { Route, Routes, Navigate } from 'react-router-dom';
import { publicRoutes, protectedRoutes } from './helper-components/Routes';
import { LoadingFallback } from './helper-components/LoadingFallback';
import { getStoredToken } from '@core/utils/auth';
import { ProtectedLayout, PublicLayout } from '@shared/layouts';
import PermissionRoute from './helper-components/PermissionRoute';
import AccessDenied from '@shared/components/AccessDenied';

// If user is not authenticated, redirect to login page
const ProtectedRoute = ({ children }: { children: React.ReactNode }) => {
  return getStoredToken() ? <>{children}</> : <Navigate to="/login" replace />;
};

const Router = () => {
  return (
    <Suspense fallback={<LoadingFallback />}>
      <Routes>
        {/* Public Routes  with public Layout*/}
        {publicRoutes.map((route, index) => {
          const Component = route.component;
          return (
            <Route
              key={`${route.module}-${index}`}
              path={route.path}
              element={
                <PublicLayout>
                  <Component />
                </PublicLayout>
              }
            />
          );
        })}

        {/* Protected Routes with protected Layout*/}
        {protectedRoutes.map((route, index) => {
          const Component = route.component;
          return (
            <Route
              key={`${route.module}-${index}`}
              path={route.path}
              element={
                <ProtectedRoute>
                  <ProtectedLayout>
                    <PermissionRoute
                      module={route.module}
                      requiresView={route.requiresView}
                      requiresAdd={route.requiresAdd}
                      requiresUpdate={route.requiresUpdate}
                      isPublic={route.isPublic}
                    >
                      <Component />
                    </PermissionRoute>
                  </ProtectedLayout>
                </ProtectedRoute>
              }
            />
          );
        })}

        {/* Access Denied Route */}
        <Route
          path="/access-denied"
          element={
            <ProtectedRoute>
              <ProtectedLayout>
                <AccessDenied />
              </ProtectedLayout>
            </ProtectedRoute>
          }
        />

        {/* When no matching route found - redirect to dashboard */}
        <Route path="*" element={<Navigate to="/" replace />} />
      </Routes>
    </Suspense>
  );
};

export default Router;
